<template>
  <div class="bg-white frame">

    <div class="frame-content tb_align-center m-t-15 m-b-25" style="padding-bottom:58px">
      <div class="tb-row p-t-15 p-b-15">
        <h1>海口市工商联动公章备案平台</h1>
      </div>

      <div class="tb-column-center m-b-15">
        <img :src="pageConfig.adImg" class="m-b-10">
      </div>

      <div class="tb-row p-25 f-14">
        <div class="f-700">单位名称：</div><div>{{aic.name}}</div>
        <div class="m-l-25 f-700">业务ID：</div><div>{{aic.busiId}}</div>
        <div class="m-l-25 f-700">联系人：</div><div>{{aic.contactName}}</div>
        <div class="m-l-25 f-700">联系手机：</div><div>{{aic.mobile}}</div>
      </div>

      <div class="p-25 bg-white">
        <Steps :current="step">
          <Step title="选择刻章店"></Step>
          <Step title="选择印章"></Step>
          <Step title="选择取货方式"></Step>
          <Step title="付款"></Step>
        </Steps>
      </div>

      <!-- START step0 选择刻章店 -->
      <div class="m-t-20 p-25 bg-white" v-if="step===0">
        <!-- 检索条件 -->
        <Row :gutter="10">
          <Col span="6">
            <TuboDist v-model="searchCompanyDist6" dict-name="dist.support" :clearable="true"
                      @on-change="getCompanySelectList(1)"></TuboDist>
          </Col>
          <Col span="6">
            <Input search v-model="searchCompanyName" enter-button="查询" placeholder="请输入刻章店名称"
                   @on-enter="getCompanySelectList(1)" @on-search="getCompanySelectList(1)"></Input>
          </Col>
        </Row>
        <!-- 刻制企业列表 -->
        <Row :gutter="10">
          <Col :span="12" class="m-t-10" v-for="(item, index) in dataPages.content" :key="index">
            <block-maker :item="item" :selected="companySelected" @click.native="selectCompany(item)"></block-maker>
          </Col>
        </Row>
        <div class="text-r p-15">
          <Page :current="dataPages.number+1" :total="dataPages.totalElements" show-elevator show-total
                :page-size="dataPages.size" size="small" @on-change="getCompanySelectList"></Page>
        </div>
        <div class="m-t-20 text-c">
          <Button type="primary" class="m-l-10" @click="stepNextTo(1)">下一步</Button>
        </div>
      </div>
      <!-- END step0 -->

      <!-- START step1 增加印章 -->
      <div class="m-t-20 p-25 bg-white" v-if="step===1">
        <div>
          <Button type="primary" @click.native="newSeal">新增印章</Button>
          <span class="p-l-20">共 {{reservation.seals.length}} 个印章，合计 {{totalPrice|currency}} </span>
        </div>
        <div class="m-t-15">
          <Row :gutter="10">
            <Col :span="12" class="m-t-10" v-for="(item,index) in reservation.seals" :key="item.id">
              <Card dis-hover>
                <div slot="title" class="tb-row-scatter h-24-px">
                  <div v-dict:DictSocietySealsite_sealType="item.sealType" class="tb-column-center"></div>
                  <div class="tb-row-center">
                    <Icon type="ios-trash-outline" size="20" class="c-h"
                          @click.native="removeSeal(item, index)"></Icon>
                  </div>
                </div>
                <Row class="p-t-10">
                  {{item.name}}
                  <Col span="8" class="text-c">
                    <ImageView :src="item.mat.matPhotoOss"></ImageView>
                  </Col>
                  <Col span="16">
                    <p class="p-5">{{item.mat.matName}}</p>
                    <p class="p-5 c-gray ti_line-height-18px h-36-px">{{item.mat.matIntro}}</p>
                    <p class="p-5 text-r">{{item.mat.matPrice|currency}}</p>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
        <div class="m-t-20 text-c">
          <Button type="primary" @click="stepPrevTo(0)">上一步</Button>
          <Button type="primary" class="m-l-10" @click="stepNextTo(2)">下一步</Button>
        </div>

        <Modal v-model="modals.seal.show" :loading="modals.seal.loading" title="新增印章"
               @on-ok="saveSeal" :width="600">
          <Form :model="modals.seal.data" :label-width="100" ref="sealForm" :rules="modals.seal.rules">

            <FormItem label="印章类型：" prop="sealType">
              <select-pro option-data="DictSocietySealsite_sealType" v-model="modals.seal.data.sealType"
                         placeholder="请选择印章类型" style="width:100%" @on-change="onChangeSealType">
              </select-pro>
            </FormItem>

            <FormItem label="印章名称：" prop="name">
              <Input v-model="modals.seal.data.name" placeholder="请输入"></Input>
            </FormItem>

            <FormItem label="印章材质：" prop="matId">
              <div v-show="!modals.seal.data.sealType">
                <div>请先选择印章类型</div>
              </div>
              <div v-show="modals.seal.material.length > 0" v-for="(item, index) in modals.seal.material" :key="index"
                   @click="modals.seal.data.matId = item.id,modals.seal.data.mat = item">
                <div class="p-l-16 p-r-16 p-t-16">
                  <div class="p-12 tb-row b-b-1" :class="{'boxShadow': modals.seal.data.matId === item.id}">
                    <div class="ti-g-1">
                      <img :src="item.matPhotoOss|img_oss" class="w-100">
                    </div>
                    <div class="ti-g-2 tb-column p-l-12">
                      <div class="tb-row-scatter">
                        <div style="width:150px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">
                          {{item.matName}}
                        </div>
                      </div>
                      <div>{{item.matPrice|currency}}</div>
                      <div class="f-12 m-t-10 c-gray">{{item.matIntro}}</div>
                    </div>
                    <div style="margin-top:-12px;margin-right:-12px">
                      <img class="w-36-px" src="img/yixuan.png" v-show="modals.seal.data.matId === item.id">
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="modals.seal.material.length === 0">本店暂时不做此类型印章</div>
            </FormItem>
          </Form>
          <div slot="footer">
            <Button @click="saveSeal" type="info">保存</Button>
          </div>
        </Modal>
      </div>
      <!-- END step1 -->

      <!-- START step2 -->
      <div class="m-t-20 p-25 bg-white" v-if="step === 2">
        <Form :label-width="100">
          <FormItem label="取章方式：">
            <select-pro option-data="EntityGzwOrder_deliverType" v-model="reservation.deliverType"
                        placeholder="请选择印章类型" style="width:100%" displayType="button">
            </select-pro>
          </FormItem>

          <div v-if="reservation.deliverType === '0'">
            <FormItem label="承刻企业名称：">{{companySelected.name}}</FormItem>
            <FormItem label="承刻企业电话：">{{companySelected.phone}}</FormItem>
            <FormItem label="承刻企业地区："><span v-dist6nameZh="companySelected.dist6"></span></FormItem>
            <FormItem label="详细地址：">{{companySelected.address}}</FormItem>
          </div>

          <div v-else-if="reservation.deliverType === '1'">
            <FormItem label="省市区/县：">
              <TuboDist v-model="reservation.deliverDist6" dict-name="dist.support" style="width: 50%"
                        :clearable="true">
              </TuboDist>
            </FormItem>
            <FormItem label="收件人姓名：">
              <Input v-model="reservation.deliverPersonName" placeholder="请输入姓名" style="width: 50%"></Input>
            </FormItem>
            <FormItem label="收件人电话：">
              <Input v-model="reservation.deliverPersonPhone" placeholder="请输入电话" style="width: 50%"></Input>
            </FormItem>
            <FormItem label="详细地址：">
              <Input type="textarea" v-model="reservation.deliverAddress" placeholder="请输入详细地址" style="width: 50%"></Input>
            </FormItem>
          </div>

          <div v-else-if="reservation.deliverType === '2'">
            <FormItem label="取章地点：">与营业执照领取地点相同</FormItem>
          </div>
        </Form>

        <div class="m-t-20 text-c">
          <Button type="primary" @click="stepPrevTo(1)">上一步</Button>
          <Button type="primary" class="m-l-10" @click="stepNextTo(3)">下一步</Button>
        </div>
      </div>
      <!-- END step2 -->

      <!-- START step3 -->
      <div class="m-t-20 p-25 bg-white" v-if="step === 3">
        <Card dis-hover>
          <p slot="title">支付总计：{{totalPrice|currency}}</p>
          <p class="p-5">印章小计：共 {{reservation.seals.length}} 个印章，合计 {{totalPrice|currency}} </p>
        </Card>

        <div class="w-70" style="margin:0 15%">
          <div class="tb-row">
            <div class="m-t-20 ti-g-1">
              <div class="f-700">微信：</div>
              <div class="m-l-80">
                <img src="img/weixin2.png">
                <div>
                  <Button class="m-t-20"
                          @click="payModal.show = true,payModal.type = 1,polling(1)">
                    去支付
                  </Button>
                </div>
              </div>
            </div>
            <div class="m-t-20 ti-g-1">
              <div class="f-700">支付宝：</div>
              <div class="m-l-80">
                <img src="img/zhifubao2.png">
                <div @click="payModal.show = true,payModal.type = 2" class="m-t-20">
                  <a :href="orderPay.aliPayUrl" target="_blank">
                    <Button @click="polling(0)">去支付</Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="m-t-20 text-c">
          <Button type="primary" @click="stepPrevTo(2)">上一步</Button>
        </div>
      </div>

      <Modal v-model="modals.pay.show" :title="modals.pay.type === 2?'支付宝付款':'微信付款'" ok-text="关闭" cancel-text=""
             @on-cancel="cancelPay" @on-ok="cancelPay">
        <div class="tb-column-center">
          <img :src="orderPay.wxPaySrc" v-if="modals.pay.type === 1">
          <div v-if="modals.pay.type === 2">请在新打开的支付宝窗口进行付款</div>
          <div>支付金额：{{totalPrice|currency}}</div>
        </div>
      </Modal>

    </div>
  </div>
</template>

<script>
  import {ImageView} from '@/components/libs'
  import {mapState} from 'vuex'
  import {api, dict, http} from '@/libs'
  import store from '@/modules'
  import BlockMaker from '@/views/components/BlockMaker'

  export default {
    components: {ImageView, BlockMaker},
    data() {
      return {
        // 工商传递过来的信息
        aic: {},
        // 刻章店名称模糊查询
        searchCompanyName : null,
        searchCompanyDist6: null,
        dataPages: {},
        companySelected: {},
        companyMaterial: [],
        // 工商预订单
        reservation: {
          seals: [],
          deliverType: "0",
        },

        modals: {
          seal: {
            show: false,
            loading: false,
            data: {matId: null, mat: null},
            material: [],
            rules: {
              name: [{required: true, trigger: 'blur', message: '请输入印章名称'}],
              sealType: [{required: true, trigger: 'change', message: '请输选择印章类型'}],
              matId: [{required: true, trigger: 'change', message: '请输选择印章材质', type: 'number'}]
            }
          },
          pay: {
            show: false,
            type: null,
          },
        },

        showPrompt: true,
        showSelectSeal: true,
        materialActive: null,
        selectedMaterialIndex: null,
        step: parseInt(this.$route.query.step) || 0,
        opUseCrp: false,
        checkState: {},

      }
    },
    watch: {
      $route(route) {
        this.step = parseInt(route.query.step) || 0
      }
    },
    computed: {
      ...mapState({
        company: state => state.order.current.company,
        pageConfig: state => state.main.config
      }),

      centerAddress() {
        if (this.companySelected.bizSetupJsonStr && this.companySelected.bizSetupJsonStr.deliver
          && this.companySelected.bizSetupJsonStr.deliver.centerAddress)
          return this.companySelected.bizSetupJsonStr.deliver.centerAddress

        return {name: null, phone: null, dist6: null, address: null,}
      },

      totalPrice() {
        return this.reservation.seals.reduce((first, second) => first + second.mat.matPrice, 0)
      },

      orderPay() {
        if (this.reservation.id) {
          return {
            wxPaySrc: api.baseUrl + api.gzwCusOrder.orderPayWxScan + this.order.id + '?token=' + localStorage.getItem('pcCustomToken'),
            aliPayUrl: api.baseUrl + api.gzwCusOrder.orderPayAlipayPc + this.order.id + '?token=' + localStorage.getItem('pcCustomToken'),
            plateform: 0
          }

        } else return {
          plateform: 0
        }
      },

    },
    methods: {
      //获取刻章店列表
      getCompanySelectList(page) {
        let conditions = []

        if (this.searchCompanyName) {
          conditions.push({op: "contains", param: "name", values: this.searchCompanyName})
        }

        let params = {
          page: page -1,
          dist6: '460102',
          jsonConditions: conditions.length > 0 ? JSON.stringify({op: "and", elements: conditions}) : null
        }

        http.get(api.libClient.companyBiz, {params: params}).then(payload => {
          this.dataPages = payload
          console.log("dataPages", this.dataPages)
        })
      },
      // 下一步
      stepNextTo(step) {
        this.step = step
      },
      // 上一步
      stepPrevTo(step) {
        this.step = step
      },
      // 选择承刻企业
      selectCompany(item) {
        if (!item.bizSetupJsonStr.netApply)
          return
        this.companySelected = item
        http.get(api.gzw.queryOrderMaterial, {params: {companyId: item.id}}).then(payload => {
          this.companyMaterial = payload
          console.log("companyMaterial", this.companyMaterial)
        })
      },

      // 翻页
      stepNext(page) {
        console.log("stepNext", page)
        if (this.order.orderState > 0) {
          if (page === 3) this.$router.push({path: '/center/seal/order/current'})
          else this.$router.push({path: this.$route.path, query: {id: this.order.id, step: page}})
        } else {
          if (page === 1) {
            if (this.order.aicDist6 == null) {
              this.order.aicDist6 = this.order.uscc.substr(2, 6)
            }
            this.params.dist6 = this.order.aicDist6
            this.getCompanySelectList()
          }

          if (page == 3 && this.order.seals == 0) {
            this.$Notice.warning({
              title: '请先增加印章'
            })
          } else {
            this.$router.push({path: this.$route.path, query: {id: this.order.id, step: page}})
            this.step = page
            Object.assign(this.order, {
              deliverPersonName: this.order.deliverType == 1 ? this.order.crpName : '',
              deliverPersonPhone: this.order.deliverType == 1 ? this.order.crpPhone : ''
            })
          }
          if (page == 3 && this.$route.query.step == 3) {
            this.setDevliverType()
          }
        }
      },
      setDevliverType() {
        dict.dict('EntityGzwOrder_deliverType').then(payload => {
          const arr = [], arr1 = []
          if (this.order.company.bizSetupJsonStr && this.order.company.bizSetupJsonStr.deliver) {
            if (this.order.company.bizSetupJsonStr.deliver.shop) arr.push(Object.entries(payload.content)[0])
            if (this.order.company.bizSetupJsonStr.deliver.express) arr.push(Object.entries(payload.content)[1])
            if (this.order.company.bizSetupJsonStr.deliver.center) arr.push(Object.entries(payload.content)[2])
            this.centerAddress = this.order.company.bizSetupJsonStr.deliver.centerAddress
            const obj = {}
            arr.forEach(item => {
              obj[item[0]] = item[1]
            })
            this.ship.deliverType = obj
          } else {
            arr1.push(Object.entries(payload.content)[0])
            arr1.push(Object.entries(payload.content)[1])
            const obj1 = {}
            arr1.forEach(item => {
              obj1[item[0]] = item[1]
            })
            this.ship.deliverType = obj1
          }
        })
      },

      saveOrderInfo() {
        store.dispatch('order/postNewEditOrder', {
          orderJson: this.order,
          id: this.order.id
        }).then(payload => {
          this.$router.push({path: this.$route.path, query: {id: this.order.id, step: 1}})
          this.stepNext(1)
        })
      },

      //保存订单
      saveOrder() {
        this.saveOrderInfo();
        // if (!this.order.orderType || this.order.orderType == 0) {
        //     this.$refs.orderForm.validate(valid => {
        //         if (valid) {
        //             this.saveOrderInfo()
        //         }
        //     })
        // } else {
        //     if(!this.isAgree) {
        //         this.$Notice.warning({title: '请先阅读并勾选委托内容'})
        //     } else {
        //         this.$refs.aicOrderForm.validate(valid => {
        //             if (valid) {
        //                 this.saveOrderInfo()
        //             }
        //         })
        //     }
        // }
      },
      //设置周期调用
      polling(type) {
        const _this = this
        this.checkState = setInterval(() => {
          store.dispatch('order/getOrderInfoById', {
            id: _this.$route.query.id
          })
          if (_this.order.orderState === '1') {
            clearInterval(_this.checkState)
            _this.$router.push({
              path: '/center/seal/order/current'
            })
          }
        }, 1000)
        this.payModal.payType = type
      },
      //取消周期调用
      cancelPay() {
        clearInterval(this.checkState)
      },

      // 保存印章
      saveSeal() {
        if (!this.modals.seal.data.matId) {
          this.$Notice.warning({title: '请选择章材'})
          return
        }
        let s = {
          sealType: this.modals.seal.data.sealType,
          name: this.modals.seal.data.name,
          matId: this.modals.seal.data.matId,
          mat: this.modals.seal.data.mat,
        }
        this.reservation.seals.push(s)
        this.modals.seal.show = false
      },

      // 删除印章
      removeSeal(item, index) {
        const _this = this
        this.$Modal.confirm({
          title: '删除印章',
          content: item.name,
          onOk() {
            _this.reservation.seals.splice(index, 1)
          }
        })
      },

      // 选择印章类型
      onChangeSealType(item) {
        if (item.value === '99' || item.value === '01') {
          this.modals.seal.data.name = this.aic.name
        } else {
          this.modals.seal.data.name = this.aic.name + item.label
        }
        this.modals.seal.material = this.companyMaterial.filter(node => node.sealType === item.value)
        this.modals.seal.data.matId = null
      },

      //新增印章
      newSeal() {
        this.modals.seal.data = {sealType: '01', matId: null, mat: null}
        this.modals.seal.material = []
        this.modals.seal.show = true
        this.onChangeSealType({value: '01'})
      },

    },

    created() {
      this.aic.busiId = this.$route.query.busiId
      this.aic.mobile = this.$route.query.mobile
      this.aic.name = this.$route.query.entName
      this.aic.contactName = this.$route.query.name

      this.getCompanySelectList(1)
      // if (this.$route.query.id) {
      //   store.dispatch('order/getOrderInfoById', {id: this.$route.query.id}).then(payload => {
      //     if (payload.uscc) {
      //       store.dispatch('order/getCompanySelectList', {dist6: payload.uscc.substr(2, 6)}).then(res => this.$forceUpdate())
      //     }
      //     if (payload.aicDist6) {
      //       store.dispatch('order/getCompanySelectList', {dist6: payload.aicDist6}).then(res => this.$forceUpdate())
      //     }
      //     if (payload.opCertNo === payload.crpCertNo && payload.opCertNo !== undefined) this.opUseCrp = true
      //     this.opUseCrpFun()
      //     if (payload.company) {
      //       this.order.companyId = payload.company.id
      //       this.selectCompanyId(this.order.companyId)
      //       this.shopSelectedIndex = this.company.poi.findIndex(item => item.id === this.order.companyId)
      //     }
      //   })
      // } else {
      //   store.commit('order/SET_CURRENT_ORDER_INFO', {
      //     crpCertType: '111',
      //     opCertType: '111',
      //     company: {},
      //     seals: []
      //   })
      //   this.opUseCrpFun()
      // }
      // if (this.$route.query.companyId) {
      //   this.showSelectSeal = false
      //   this.order.companyId = this.$route.query.companyId
      //   this.selectCompanyId(this.order.companyId)
      // }
      // dict.dict('DictSocietySealsite_sealType').then(payload => this.sealModal.sealType = payload.content)
      // this.setDevliverType()
      // console.log(this.order.companyId, !this.showPrompt, this.order.seals, this.order.seals.length < 1, !(this.order.orderState > 0))
    }

  }
</script>

<style lang="less">
  .box {
    box-shadow: 0px 2px 8px #bbb;
  }

  .selected {
    margin-left: -8px;
    position: absolute;
    top: 0px;
    opacity: 0.4;
    background: #000;
    width: 100%;
    height: 100%;
  }

  .selected1 {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
  }

  .boxShadow {
    box-shadow: 0px 1px 11px #999;
  }

  .frame {
    position: absolute;
    min-height: 100%;
    width: 100%;
    min-width: 1140px;
    overflow: auto;
  }

  .frame-content {
    margin: 0 auto;
    max-width: 1140px;
  }

  .user_footer {
    position: inherit;
    bottom: 0;
    width: 100%;
  }

  .layout {
    display: flex;

    .left {
      width: 150px;
    }

    .right {
      margin-left: 20px;
      width: 970px;
    }
  }
</style>